import { observable, reaction } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import BaseModalStore from '../layout/base-store';

const language = getLanguageByPath();

class PedigreeChartModalStore extends BaseModalStore {
  name = '机兵谱系图弹窗';

  swiper = new BaseSwiperStore({
    swiperOptions: {
      slidesPerView: 4,
      spaceBetween: 0,
      allowTouchMove: true,
      autoplay: false,
      loopSlides: 1,
      slideToClickedSlide: true,
      grabCursor: true
    }
  });

  @observable chart = '';
  @observable currentIndex = '';

  tabList = [
    {
      src: require(`./images/tab-qingjian/${language}.png`),
      chart: require(`./images/qingjian/${language}.png`)
    },
    {
      src: require(`./images/tab-fuhu/${language}.png`),
      chart: require(`./images/fuhu/${language}.png`)
    },
    {
      src: require(`./images/tab-jiaolang/${language}.png`),
      chart: require(`./images/jiaolang/${language}.png`)
    },
    {
      src: require(`./images/tab-other/${language}.png`),
      chart: require(`./images/other/${language}.png`)
    }
  ];

  onTabChange = (item, idx) => {
    this.currentIndex = idx;
    this.chart = item.chart;
    this.swiper.onChange(idx);
  };

  use() {
    super.use();

    useMount(() => {
      reaction(
        () => this.level,
        val => {
          val && this.onTabChange(this.tabList[0], 0);
        },
        {
          fireImmediately: true
        }
      );

      reaction(
        () => this.swiper.activeIndex,
        val => {
          this.onTabChange(this.tabList[val], val);
        }
      );
    });
  }
}

export default PedigreeChartModalStore;
